import React from "react";
import {  OrderStatus } from "states/order/order.models";

interface IOrderStatusProps {
  orderStatus: OrderStatus;
}
export const OrderStatusComponent = (props: IOrderStatusProps) => {
  const {orderStatus} = props;
  const renderStatus = ()=>{
    switch (orderStatus){
      case OrderStatus.Cancel:
        return <React.Fragment>Hủy đơn hàng</React.Fragment>;
      case OrderStatus.Processing:
        return <React.Fragment>Đợi duyệt</React.Fragment>;
      case OrderStatus.Shipping:
        return <React.Fragment>Đang giao hàng</React.Fragment>;  
      case OrderStatus.Completed:
        return <React.Fragment>Hoàn thành</React.Fragment>; 
      default:
        return <React.Fragment />
    }
  }
  return (renderStatus());
};
